import { AlertFOCItemDTO } from '@models/api/AlertFOCItemDTO'
import { BurnedAreaItem } from '@models/BurnedAreaItem'
import { ConfirmDialogOptions } from '@models/ConfirmDialogOptions'
import { Position } from '@models/map/Position'
import { OverlayLevel } from '@models/overlay/OverlayLevel'
import { SimulationListItem } from '@models/simulation/SimulationListItem'
import { Dayjs } from 'dayjs'
import { Feature, Geometry } from 'geojson'
import mitt from 'mitt'
import { ToastMessageOptions } from 'primevue/toast'

export interface OpenMapPopupEvent {
  position?: Position
  marker?: L.Marker
  burnedArea?: Feature<Geometry, BurnedAreaItem>
}

type Events = {
  centerMap: Position
  openMapPopup: OpenMapPopupEvent
  closeMapPopup: void
  centerMapOnPopup: Position
  openPerfilVertical: Position
  openMeteograma: Position
  openENS: Position
  openGIMMS: Position
  unitSystemChanged: void
  sliderStartDateChanged: Dayjs
  sliderEndDateChanged: Dayjs | undefined
  sliderSelectDate: Dayjs | undefined
  simulationSurface: number
  showToast: ToastMessageOptions
  showConfirmDialog: ConfirmDialogOptions
  overlaysChanged: OverlayLevel[]
  selectAlertZone: string
  selectAlertFOC: AlertFOCItemDTO['CODE_INE']
  openThundersDialog: boolean
  simulate: __esri.Graphic
  moveSliderToDate: Dayjs
  openDownloadDialog: boolean
  simulationComplete: SimulationListItem
  simulationFileComplete: SimulationListItem
}

export const emitter = mitt<Events>()
